// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1L4wi","col":"styles_col__3-cku","fulfillmentStatus":"styles_fulfillmentStatus__1-T9N","emailCol":"styles_emailCol__1ldbG"};